import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import { switchModal, hideModal } from "~/store/ducks/domain/ui/modal";
import { styled } from "@mui/material/styles";

const StyledButton = styled(Button)(({ theme }) => ({
  "&:focus-visible": {
    outline: theme.outline(),
    outlineOffset: "-2px"
  }
}));

function DialogFooter({ isEditMode, switchModal, hideModal }) {
  function onEdit() {
    switchModal("EDIT_MATERIAL");
  }

  function onClose() {
    hideModal();
  }

  return (
    <DialogActions>
      {isEditMode && (
        <StyledButton variant="text" color="primary" onClick={onEdit}>
          Bearbeiten
        </StyledButton>
      )}
      <StyledButton variant="text" color="primary" onClick={onClose}>
        Schließen
      </StyledButton>
    </DialogActions>
  );
}

DialogFooter.propTypes = {
  switchModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool
};

const mapDispatchToProps = {
  switchModal,
  hideModal
};

export default connect(null, mapDispatchToProps)(DialogFooter);
